import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const GetRoles = createAction('[Shared: Roles]: Get Roles');

export const GetRolesSuccess = createAction(
  '[Shared: Roles]: Get Roles Success',
  props<{ roles: any }>(),
);

export const GetRolesFailed = createAction(
  '[Shared: Roles]: Get Roles Failed',
  props<{ error: HttpErrorResponse }>(),
);
